import IndustryActivity from "../../components/industryActivity/IndustryActivity.jsx";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT as EV_INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent as evIndustryHasActivityContent,
  isIndustryActivityAnswered as isEvIndustryActivityAnswered,
} from "../../utils/industryActivity.js";

const EvIndustryActivity = () => <IndustryActivity />;

export default EvIndustryActivity;
